import { render, staticRenderFns } from "./preorders.vue?vue&type=template&id=7936a3e6"
import script from "./preorders.vue?vue&type=script&lang=js"
export * from "./preorders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports